<app-dashboard>
    <div class="page">
        <app-filter [data]="this.data" (filterChanged)="onFilterChanged($event)"></app-filter>
        <!-- <div class="table">
            <app-table [action]="singleRequest" [fetchingData]="fetchingData" [headers]="tableHeaders" [data]="tableData"></app-table>
        </div> -->
        <app-request-table [data]="requests" [view]="singleRequest" [processLoading]="fetchingData"></app-request-table>
        <app-pagination *ngIf="!this.fetchingData && this.totalList > 0"
            [totalItems]="this.totalList" [(pageSize)]="this.limit"
            [(currentPage)]="this.page" (pageSizeChange)="this.refreshRequests()"
            (currentPageChange)="this.getRequests()"></app-pagination>
    </div>
</app-dashboard>

<app-modal
[title]="this.webhookConfig.name"
[dateCreated]="this.webhookConfig.createdAt"
[dateUpdated]="this.webhookConfig.updatedAt"
  [isOpen]="isModalOpen2"
  (closeModalEvent)="closeModal()"
>
  <div *ngIf="this.individualRequest" class="table-grid">
    <span class="key">Webhook ID</span>
    <span class="value">{{ this.individualRequest._id }}</span>

    <span class="key">Name</span>
    <span class="value">{{ this.webhookConfig.name }}</span>

    <span class="key">Created At</span>
    <span class="value">{{ this.webhookConfig.createdAt }}</span>

    <span class="key">Method</span>
    <span class="value">{{ this.individualRequest.method }}</span>

    <span class="key">URL</span>
    <span class="value">{{ this.individualRequest.url }}</span>

    <span class="key"> Status</span>
    <span class="value">{{ this.individualRequest.status }}</span>

    <span class="key">Response Status</span>
    <span class="value">{{ this.individualRequest.responseStatus }}</span>

    <span class="key">Trials</span>
    <span class="value">{{ this.individualRequest.trials }}</span>

    <span class="key">Required Trials</span>
    <span class="value">{{ this.individualRequest.requiredTrials }}</span>
<!-- 
    <span class="key">Request Body</span>
    <div class="value box" *ngIf="individualRequest?.body">
      <div *ngFor="let key of getObjectKeys(individualRequest.body)">
        {{ key }}: {{ individualRequest.body[key] | json }}
      </div>
    </div>

    <span class="key">Response Body</span>
    <div class="value box" *ngIf="individualRequest?.response && individualRequest.response.length > 0">
        <div *ngFor="let key of getObjectKeys(individualRequest.response[0]?.body)">
          {{ key }}: {{ individualRequest.response[0]?.body[key] | json }}
        </div>
      </div> -->

      <span class="key">Request Body</span>
      <div class="value box" *ngIf="individualRequest?.body">
        <ngx-json-viewer [json]="individualRequest?.body"></ngx-json-viewer>
      </div>
  
      <span class="key">Response Body</span>
      <div
        class="value box"
        *ngIf="
          individualRequest?.response && individualRequest.response.length > 0">
        <ngx-json-viewer [json]="individualRequest?.response"></ngx-json-viewer>
      </div>
  </div>
  <!-- <div class="detail-section"> -->
  <!-- <div class="sub-detail">
        <h1>Webhook ID</h1>
        <p>{{this.individualRequest._id}}</p>
       </div>
       <div class="sub-detail">
        <h1>Name</h1>
        <p>{{this.webhookConfig.name}}</p>
       </div>
       <div class="sub-detail">
        <h1>Created At</h1>
        <p>{{this.webhookConfig.createdAt}}</p>
       </div>
       <div class="sub-detail">
        <h1>Method</h1>
        <p>{{this.individualRequest.method}}</p>
       </div>
       <div class="sub-detail">
        <h1>URL</h1>
        <p>{{this.individualRequest.url}}</p>
       </div>
       <div class="sub-detail">
        <h1>Response Status</h1>
        <p>{{this.individualRequest.responseStatus}}</p>
       </div>
       <div class="sub-detail">
        <h1>Trials</h1>
        <p>{{this.individualRequest.trials}}</p>
       </div>
       <div class="sub-detail">
        <h1>Required Trials</h1>
        <p>{{this.individualRequest.requiredTrials}}</p>
       </div>
       <div class="sub-detail">
        <h1>Response</h1>
        <div *ngIf="individualRequest.response && individualRequest.response.length > 0" [innerHTML]="individualRequest.response[0].body"></div>
       </div> -->

  <!-- </div> -->

  <!-- <div class="button"><app-button-outline [action]="closeModal" buttonText="Close"></app-button-outline></div> -->
</app-modal>
